export default {
  name: 'Login',
  path: '/login',
  component: () => import('./login-page.vue')
};
